import React from "react";
import { Route, Switch } from "react-router-dom";
import { Col } from "react-bootstrap";
import PlanPage from "../PlanPage";


const NoPlanIdRouting = (props) => {

    return (
    <>
      <Col name="no-planid-routing">
          <Switch>           
            <Route exact path="/options/plans/:pathPlanCmdOrPlanId" component={PlanPage} />           
            <Route exact path="/options/plans/:pathplanid/groups" component={PlanPage} />         
          </Switch>
      </Col>
    </>
  );

};

export default NoPlanIdRouting;